module.exports = __webpack_public_path__ + "img/play_big.9f372f2.png";